import React from 'react'
import { Container } from 'react-bootstrap'
import { Fade } from 'react-reveal'
import Brochure1 from '../../../assets/pdf/Brochure1.pdf'
import Brochure2 from '../../../assets/pdf/Brochure2.pdf'
import FloorPlan from '../../../assets/pdf/FloorPlan.pdf'
import useFetch from '../../../Hooks/useFetch'
import { saveAs } from 'file-saver'
import './view-plans.scss'

import GetAppIcon from '@material-ui/icons/GetApp'

export default function ViewPlans({ projectNumber }) {
  const { data } = useFetch()
  console.log(projectNumber?.fields.vFloorFile)
  // const files = projectNumber?.fields.vBrochureFile
  // console.log(files)
  const handleDownload = (files) => {
    if (files) {
      files.map((URL, idx) => saveAs(URL?.fields.file.url, `example${idx}.pdf`))
    } else {
      return
    }
  }
  return (
    <div id='view-plans'>
      <Container>
        <Fade bottom cascade>
          <ul className='view-wrap'>
            <li className='view-box'>
              <button
                style={{ cursor: 'pointer' }}
                onClick={() =>
                  handleDownload(projectNumber?.fields.vBrochureFile)
                }
              >
                {projectNumber?.fields.vBrouchure}
                <span>
                  <GetAppIcon />
                </span>
              </button>
            </li>
            <li className='view-box'>
              <button
                style={{ cursor: 'pointer' }}
                onClick={() => handleDownload(projectNumber?.fields.vFloorFile)}
              >
                {projectNumber?.fields.vFloor}
                <span>
                  <GetAppIcon />
                </span>
              </button>
            </li>
          </ul>
        </Fade>
      </Container>
    </div>
  )
}
